import { Component, OnInit } from '@angular/core';
import { FieldArrayType } from '@ngx-formly/core';
import {TranslateService} from '@ngx-translate/core';
@Component({
  selector: 'app-workflow-step-action',
  templateUrl: './workflow-step-action.component.html',
  styleUrls: ['./workflow-step-action.component.css'],
})
export class WorkflowStepActionComponent extends FieldArrayType {}
